// A verification submit failure the screen can show to the candidate: a
// translation key and its values, instead of the raw network error.
export class VerificationSubmitError extends Error {
  translationKey: string;

  values?: unknown[];

  constructor(translationKey: string, values?: unknown[]) {
    super(translationKey);
    this.name = 'VerificationSubmitError';
    this.translationKey = translationKey;
    this.values = values;
  }
}

// "There was a problem submitting your verification. Please try again, or
// visit our help center." Used when the request got no response (offline,
// dropped connection).
export const SUBMIT_FAILED_KEY =
  'components.Verification.DocumentsPanel.generic';

export const INVALID_SIZE_KEY =
  'components.Verification.DocumentsPanel.invalid_size';
